import * as React from 'react';



export default class Activityies extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
		<svg id="activities" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
       <g id="left-nav-primary-icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-144.000000, -133.000000)">
            <g id="Group-3" transform="translate(144.000000, 133.000000)">
                <g id="Group-3-Copy-5" transform="translate(2.000000, 2.000000)">
                    <path d="M16.1,19.25 L17.6,19.25 L17.6,20.9 C17.6,21.5075132 17.1075132,22 16.5,22 L1.1,22 C0.492486775,22 7.43989126e-17,21.5075132 0,20.9 L0,5.5 C-7.43989126e-17,4.89248678 0.492486775,4.4 1.1,4.4 L2.75,4.4 L2.75,5.9 L1.5,5.9 L1.5,20.5 L16.1,20.5 L16.1,19.25 Z" id="Rectangle-3-Copy" fill="#333333" fillRule="nonzero"></path>
                    <g id="Group-5" transform="translate(4.400000, 0.000000)">
                        <rect id="Rectangle-3" stroke="#333333" strokeWidth="1.5" x="0.75" y="0.75" width="16.1" height="16.1" rx="1"></rect>
                        <text id="A" fontFamily="Roboto-Bold, Roboto" fontSize="12" fontWeight="bold" fill="#333333">
                            <tspan x="4.80001221" y="12.8">A</tspan>
                        </text>
                    </g>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}
